import { render, staticRenderFns } from "./QuestionExamAdd.vue?vue&type=template&id=3ab4d4ef&scoped=true&"
import script from "./QuestionExamAdd.vue?vue&type=script&lang=js&"
export * from "./QuestionExamAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuestionExamAdd.vue?vue&type=style&index=0&id=3ab4d4ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab4d4ef",
  null
  
)

export default component.exports